import axios from "axios";
import { getAuthToken, AUTH_TOKEN_HEADER } from "../../utils/auth";

const baseUrl = process.env.REACT_APP_BASE_URL + "api/v1/carousel";

function authHeaders(extra = {}) {
  const token = getAuthToken();
  const headers = { ...extra };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
    headers[AUTH_TOKEN_HEADER] = token;
    headers["rf-token-header123-k"] = token;
  }
  return headers;
}

export function getBanners() {
  return axios.get(baseUrl, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
}

export function getBanner(id) {
  return axios.get(`${baseUrl}/${id}`, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
}

export function createBanner(data) {
  // Let the browser set multipart boundary for FormData
  return axios.post(baseUrl, data, {
    headers: authHeaders(),
  });
}

export function updateBanner(id, data) {
  return axios.put(`${baseUrl}/${id}`, data, {
    headers: authHeaders(),
  });
}

export function deleteBanner(id) {
  return axios.delete(`${baseUrl}/${id}`, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
}
